import DefaultIcon from '../../assets/images/default icon.png';
import { getProviderImagePath } from './imageUtils';

/** Newer ground couriers that follow the established logo'd list. */
export const GROUND_END_TITLES = [
  'DPD',
  'OnTrac',
  'TNT',
  'Trump Card',
  'UniUni',
  // Previously sorted alphabetically above FedEx; keep after established brands.
  'CryoPDP',
  'Landstar',
  'Medical Courier',
  'Royale',
  'TQL',
  'Team Worldwide',
  'Yourway',
] as const;

/** Always last in the Ground picker, after logo-less / test couriers. */
export const GROUND_LAST_TITLES = ['Life Couriers'] as const;

export const hasTransportProviderImage = (title: string): boolean =>
  getProviderImagePath(title, 'transportProvider') !== DefaultIcon;

/**
 * Ground picker order: providers with logos first, then logo-less (test/made-up
 * couriers stay at the end until they get art). Within each group, keep the
 * newer GROUND_END_TITLES after the established brands. GROUND_LAST_TITLES
 * (Life Couriers) always sort after everything else.
 */
export const compareGroundTransportProviders = (
  a: { title: string },
  b: { title: string }
): number => {
  const aLast = (GROUND_LAST_TITLES as readonly string[]).indexOf(a.title);
  const bLast = (GROUND_LAST_TITLES as readonly string[]).indexOf(b.title);
  if (aLast !== -1 || bLast !== -1) {
    if (aLast === -1) return -1;
    if (bLast === -1) return 1;
    return aLast - bLast;
  }

  const aHasLogo = hasTransportProviderImage(a.title);
  const bHasLogo = hasTransportProviderImage(b.title);
  if (aHasLogo !== bHasLogo) {
    return aHasLogo ? -1 : 1;
  }
  const aEnd = (GROUND_END_TITLES as readonly string[]).indexOf(a.title);
  const bEnd = (GROUND_END_TITLES as readonly string[]).indexOf(b.title);
  if (aEnd === -1 && bEnd === -1) return 0;
  if (aEnd === -1) return -1;
  if (bEnd === -1) return 1;
  return aEnd - bEnd;
};
